module.exports = __webpack_public_path__ + "static/media/recojehojasbolsa.9eda896c.jpg";